import React from "react";
import { motion } from "framer-motion";
import { CONTACT } from "@/lib/pnp";
import { MessageCircle } from "lucide-react";

export default function FloatingWhatsApp() {
  return (
    <motion.a
      data-testid="floating-whatsapp"
      href={CONTACT.whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp Kontakt"
      initial={{ opacity: 0, y: 20, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ delay: 1.6, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className="pp-pulse fixed bottom-5 right-5 md:bottom-8 md:right-8 z-50 inline-flex items-center gap-2 rounded-full bg-[#17C964] text-[#082E19] font-semibold pl-4 pr-5 py-3 shadow-lg"
    >
      <MessageCircle size={18} strokeWidth={2.2} />
      <span className="hidden sm:inline">WhatsApp</span>
    </motion.a>
  );
}
